<template>
  <c-row>
    <c-col col="12">
      <loader v-show="loading" />
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Informasi COA</strong>
            <div class="card-header-actions">
              <date-range @select="changeDate" />
            </div>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div class="form-group">
            <label>Cari berdasarkan kata kunci</label>
            <input
              type="text"
              class="form-control"
              v-model="q"
              @keypress="search"
            />
          </div>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Kode</th>
                  <th>Nama</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody v-if="report.data && report.data.length <= 0">
                <tr>
                  <td colspan="13" class="center">
                    Data tidak ditemukan untuk range tanggal
                    <strong
                      >{{ dateRange.startDate.format("DD-MMM-YYYY") }} sd.
                      {{ dateRange.endDate.format("DD-MMM-YYYY") }}</strong
                    >
                  </td>
                </tr>
              </tbody>
              <tbody v-if="report.data && report.data.length > 0">
                <tr v-for="(v, k) in report.data" :key="k">
                  <td>
                    <table-number
                      :page="report.paginate.current_page"
                      :size="report.paginate.per_page"
                      :index="k"
                    />
                  </td>
                  <td>{{ v.code }}</td>
                  <td>{{ v.name }}</td>
                  <td class="right">{{ 0 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <CPagination
            align="end"
            :active-page.sync="currentPage"
            :pages="Math.ceil(total / perPage)"
            responsive
          />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH, HTTPExport } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber";
import DateRange from "../../components/DateRange";
import Loader from '../../components/Loader.vue';

export default {
  data () {
    return {
      report: {},
      currentPage: 1,
      total: 0,
      perPage: 10,
      startMonth: moment(moment().format("YYYY-MM-") + "01"),
      dateRange: null,
      q: '',
      loading: false
    };
  },
  components: {
    TableNumber,
    DateRange,
    Loader,
  },
  created () {
    this.dateRange = null;
    // {
    //   startDate: this.startMonth,
    //   endDate: moment()
    // }
    this.getList(1, this.q);
  },
  methods: {
    getList (page, q) {
      this.loading = true
      var dateRange = "";
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
        dateRange = `&start_date=${startDate}&end_date=${endDate}`;
      }
      HTTPAUTH.get(
        `/api/v1/coa/paged/items?page=${page}&size=${this.perPage}&q=${q}${dateRange}`
      ).then((res) => {
        this.report = res.data;
        if (res.data.data.length <= 0) {
          this.report = {
            data: []
          }
        }
        this.currentPage = page;
        this.total = this.report.paginate.total;
        this.$router.push({
          query: { q: q, page: page, start: startDate, end: endDate },
        }).catch(() => { });
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.report = [];
      });
    },
    changeDate (v) {
      this.dateRange = {
        startDate: moment(v.startDate),
        endDate: moment(v.endDate),
      };
      this.getList(1, this.q);
    },
    search (evt) {
      if (evt.keyCode == 13) {
        this.getList(1, this.q);
      }
    },
    async exportExcel () {
      this.loading = true
      await HTTPExport.post(`/api/v1/info-account/debt`).then(res => {
        const data = res.data.data;
        window.open(data, '_blank');
      }).catch(() => {
        this.loading = false
      })
      this.loading = false
    },
  },
  watch: {
    currentPage (pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.getList(pageNext, q);
    },
  },
};
</script>